/**
 * Extracts the property subdomain from the current hostname by checking
 * against a list of known base domains. Returns `null` when the hostname
 * is already a base domain or is unknown.
 *
 * Example: `iru.staffapp-acc.ireckonu.com` → `"iru"`
 */
export function getSubdomainFromHostname(hostname: string): string | null {
  const baseDomains = [
    'localhost',
    'localhost.com',
    'staffapp-dev.ireckonu.com',
    'staffapp-acc.ireckonu.com',
    'staffapp.ireckonu.com',
  ];

  for (const base of baseDomains) {
    const suffix = `.${base}`;
    if (hostname.length > suffix.length && hostname.endsWith(suffix)) {
      return hostname.slice(0, hostname.length - suffix.length);
    }
  }

  return null;
}

/**
 * Returns the base origin (protocol + base hostname + port) by stripping
 * any tenant subdomain from the current window location.
 *
 * Example: `http://iru.localhost:8100` → `http://localhost:8100`
 */
export function getBaseOrigin(): string {
  const url = new URL(window.location.origin);
  const subdomain = getSubdomainFromHostname(url.hostname);
  if (subdomain) {
    url.hostname = url.hostname.slice(subdomain.length + 1);
  }
  return url.origin;
}
